import { Check } from "@phosphor-icons/react";

const STEPS = [
  { key: "eingereicht", label: "Kontakt eingereicht" },
  { key: "in_bearbeitung", label: "In Bearbeitung" },
  { key: "termin", label: "Termin" },
  { key: "kunde_geworden", label: "Kunde geworden" },
];

export function ProgressTracker({ status }) {
  const current = STEPS.findIndex((s) => s.key === status);
  return (
    <div className="flex flex-col" data-testid="progress-tracker">
      {STEPS.map((step, i) => {
        const done = i <= current;
        const active = i === current;
        const isLast = i === STEPS.length - 1;
        return (
          <div key={step.key} className="flex gap-3">
            <div className="flex flex-col items-center">
              <div
                className={`flex h-8 w-8 items-center justify-center rounded-full border transition-colors duration-300 ${
                  done ? "border-[#C5A059] bg-[#C5A059] text-white" : "border-[#E2E8F0] bg-white text-transparent"
                }`}
              >
                {done ? <Check size={16} weight="bold" /> : <span className="h-1.5 w-1.5 rounded-full bg-[#CBD5E0]" />}
              </div>
              {!isLast && (
                <div className={`w-px flex-1 min-h-[26px] ${i < current ? "bg-[#C5A059]" : "bg-[#E2E8F0]"}`} />
              )}
            </div>
            <div className={`pb-4 pt-1 text-[15px] ${active ? "font-bold text-[#0A1128]" : done ? "font-semibold text-[#0A1128]" : "text-[#A0AEC0]"}`}>
              {step.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
